import React from "react";
import "./MatchCard.css";

const MatchCard = ({ match, onClick }) => {
    const { competition, date, time, home, away, home_score, away_score } = match;

    // Convertir la date au format souhaité
    const formatDate = (date) => {
        const options = { day: "numeric", month: "long", year: "numeric" };

        return new Date(date).toLocaleDateString("fr-FR", options);
    };


    return (
        <div className="match-card" onClick={() => onClick(match)}>
            {/* Competition, date et heure */}
            <div className="table-header">
                <span className="competition-name">{competition.name}</span>
                <span className="match-date-time">
                    {formatDate(date)} - {time}
                </span>
            </div>

            {/* Teams and score */}
            <div className="teams-container">
                {/* Home team */}
                <div className="team home-team">
                    {home && home.club && home.short_name ? (
                        <>
                            <img
                                src={home.club.logo}
                                alt={home.short_name}
                                className="team-logo"
                            />
                            <span className="team-name">{home.short_name}</span>
                        </>
                    ) : (
                        <div className="placeholder-logo"></div> // Placeholder gris
                    )}
                </div>

                {/* Score */}
                <div className="score">
                    {home_score !== null && away_score !== null
                        ? `${home_score} - ${away_score}`
                        : "-"}
                </div>

                {/* Away team */}
                <div className="team away-team">
                    {away && away.club && away.short_name ? (
                        <>
                            <span className="team-name">{away.short_name}</span>
                            <img
                                src={away.club.logo}
                                alt={away.short_name}
                                className="team-logo"
                            />
                        </>
                    ) : (
                        <div className="placeholder-logo"></div> // Placeholder gris
                    )}
                </div>
            </div>
        </div>
    );
};

export default MatchCard;
